import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/img/icon/edit-box-blue.svg'
import _imports_1 from '@/assets/img/icon/delete-box-red.svg'


const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-12 gap-2 lg:gap-4"
}
const _hoisted_2 = {
  key: 1,
  class: "grid grid-cols-12 gap-2 lg:gap-4"
}
const _hoisted_3 = { class: "grid grid-cols-12 gap-2 lg:gap-3" }
const _hoisted_4 = { class: "flex items-center gap-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-base font-bold break-all" }
const _hoisted_8 = { class: "text-sm font-normal text-grey break-all" }
const _hoisted_9 = { class: "text-xs font-normal text-grey break-all" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "lg:flex gap-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "mt-2 px-5 py-3 col-span-12 background-grey-2 rounded-lg" }
const _hoisted_15 = { class: "flex items-center justify-between" }
const _hoisted_16 = { class: "text-base font-bold" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_20 = { class: "text-left break-words font-bold text-sm" }
const _hoisted_21 = { class: "text-left break-words text-sm" }
const _hoisted_22 = { class: "text-left break-words text-sm" }
const _hoisted_23 = { class: "text-left break-words text-sm" }
const _hoisted_24 = { class: "font-bold text-sm mb-1" }
const _hoisted_25 = { class: "text-left break-words font-bold text-sm" }
const _hoisted_26 = { class: "font-normal" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode()
const _hoisted_28 = { class: "text-red" }
const _hoisted_29 = { class: "clm-act-cntn" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Atur ")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down text-black ml-4" }, null, -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_35 = { class: "clm-act-cntn" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Atur ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down text-black ml-4" }, null, -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_ListActions = _resolveComponent("ListActions")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_VehicleMutationForm = _resolveComponent("VehicleMutationForm")!
  const _component_HjpDefaultModal = _resolveComponent("HjpDefaultModal")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!
  const _component_EditSlotForm = _resolveComponent("EditSlotForm")!
  const _component_HjpSideBar = _resolveComponent("HjpSideBar")!
  const _component_HjpAlertModal = _resolveComponent("HjpAlertModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isRegular)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["text-sm font-bold text-grey break-all", item.class]),
              key: key
            }, _toDisplayString(item.title.toUpperCase()), 3))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaderReserve, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["text-sm font-bold text-grey break-all", item.class]),
              key: key
            }, _toDisplayString(item.title.toUpperCase()), 3))
          }), 128))
        ])),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (data, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "trayek-list py-4"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.isRegular ? 'col-span-3' : 'col-span-6')
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.isRegular)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_Popper, {
                        arrow: "",
                        hover: "",
                        placement: "bottom",
                        content: data.IsTol ? 'Tol' : 'Non Tol'
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: require(data.IsTol ? '@/assets/img/icon/toll-blue-fill.svg' : '@/assets/img/icon/toll-blue-fill-with-cross.svg'),
                            alt: "toll"
                          }, null, 8, _hoisted_6)
                        ]),
                        _: 2
                      }, 1032, ["content"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, _toDisplayString(data.Name), 1)
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(data.Code), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(`${_ctx.moment(data.StartDate.toString()).format('DD/MM/YYYY')} -
                        ${_ctx.moment(data.EndDate.toString()).format('DD/MM/YYYY')}`), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.isRegular ? 'text-base font-normal break-all col-span-2' : 'text-base font-normal break-all col-span-5')
            }, _toDisplayString(data.MsClass.Name), 3),
            (_ctx.isRegular)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: _ctx.formatRit(data.TrayekRoute),
                  class: "text-base font-normal text-grey col-span-5 break-normal"
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "edit",
                  class: "cursor-pointer mb-2 lg:mb-0",
                  style: {"width":"35px","height":"35px"},
                  onClick: ($event: any) => (_ctx.$router.push({
                  name: `${_ctx.path}-form`,
                  params: {
                    id: data.Id
                  },
                }))
                }, null, 8, _hoisted_12)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "delete",
                  class: "cursor-pointer",
                  style: {"width":"35px","height":"35px"},
                  onClick: ($event: any) => (_ctx.onDeleteHeader(data))
                }, null, 8, _hoisted_13)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(`Lihat (${data.TrayekDetailsCount}) Bus Terdaftar`), 1),
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: "pi pi-chevron-down cursor-pointer",
                  onClick: ($event: any) => (_ctx.showDetailPage(data.Id))
                }, null, 8, _hoisted_17)
              ])
            ]),
            (_ctx.showDetailId === data.Id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.isAirport)
                    ? (_openBlock(), _createBlock(_component_DataTable, {
                        key: 0,
                        value: _ctx.datatableSource,
                        class: "trayek-list-detail"
                      }, {
                        empty: _withCtx(() => [
                          _hoisted_19
                        ]),
                        loading: _withCtx(() => [
                          _createVNode(_component_ProgressSpinner, { style: {"width":"70px","height":"70px"} })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            field: "RegNumber",
                            header: "Nopol",
                            style: {"width":"150px"}
                          }, {
                            body: _withCtx(({ data, field }) => [
                              _createElementVNode("p", _hoisted_20, _toDisplayString(data[field]), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_Column, {
                            field: "HullNumber",
                            header: "No. Lambung",
                            style: {"min-width":"100px"}
                          }, {
                            body: _withCtx(({ data, field }) => [
                              _createElementVNode("p", _hoisted_21, _toDisplayString(data[field]), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_Column, {
                            field: "PurchasedAt",
                            header: "Tahun Pembuatan",
                            style: {"min-width":"100px"}
                          }, {
                            body: _withCtx(({ data, field }) => [
                              _createElementVNode("p", _hoisted_22, _toDisplayString(data[field]), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_Column, {
                            field: "Type",
                            header: "Tipe / Karoseri",
                            style: {"min-width":"100px"}
                          }, {
                            body: _withCtx(({ data, field }) => [
                              _createElementVNode("p", _hoisted_23, _toDisplayString(data[field]), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_Column, {
                            header: "Rit",
                            style: {"min-width":"100px"}
                          }, {
                            body: _withCtx(({ data }) => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.TrayekSubs, (items) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: items,
                                  class: "mb-3"
                                }, [
                                  _createElementVNode("p", _hoisted_24, _toDisplayString(`PP${items.Order}`), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.groupTrayekSubsDetails, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: item }, [
                                      _createElementVNode("p", _hoisted_25, [
                                        _createTextVNode(_toDisplayString(`Rit ${index + 1}`) + " ", 1),
                                        _createElementVNode("span", _hoisted_26, _toDisplayString(`(${item[0].RitDepartureTime.slice(0, 5)} - ${item[item.length - 1].RitArrivalTime.slice(0, 5)})`), 1),
                                        _hoisted_27,
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(`${items.IsCrossDay ? '(Lintas Hari)' : ''}`), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_Column, {
                            class: "colom-action mx-auto",
                            header: "Aksi"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", {
                                  class: "w-fit px-4 py-2 flex items-center cursor-pointer rounded-lg border-grey-lighten-4",
                                  onClick: ($event: any) => (_ctx.showDropDown($event, slotProps.data))
                                }, _hoisted_33, 8, _hoisted_30)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    : (_openBlock(), _createBlock(_component_DataTable, {
                        key: 1,
                        value: _ctx.datatableSource,
                        class: "trayek-list-detail"
                      }, {
                        empty: _withCtx(() => [
                          _hoisted_34
                        ]),
                        loading: _withCtx(() => [
                          _createVNode(_component_ProgressSpinner, { style: {"width":"70px","height":"70px"} })
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailHeader, (y) => {
                            return (_openBlock(), _createBlock(_component_Column, {
                              key: y.field,
                              field: y.field,
                              header: y.headerName,
                              style: _normalizeStyle(y.field === 'nopol' ? 'width: 200px;' : 'min-width: 100px;')
                            }, null, 8, ["field", "header", "style"]))
                          }), 128)),
                          _createVNode(_component_Column, {
                            class: "colom-action mx-auto",
                            header: "Aksi"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", {
                                  class: "w-fit px-4 py-2 flex items-center cursor-pointer rounded-lg border-grey-lighten-4",
                                  onClick: ($event: any) => (_ctx.showDropDown($event, slotProps.data))
                                }, _hoisted_39, 8, _hoisted_36)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"])),
                  _createElementVNode("div", null, [
                    (_ctx.datatableSource.length > 0)
                      ? (_openBlock(), _createBlock(_component_Paginator, {
                          key: 0,
                          class: "trayek-pagination",
                          rows: _ctx.paginate.pageSize,
                          totalRecords: _ctx.totalRecords,
                          onOnPage: _ctx.onChangePageDetail
                        }, null, 8, ["rows", "totalRecords", "onOnPage"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", null, [
        (_ctx.dataSource.length > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              class: "trayek-pagination",
              rows: _ctx.filters.pageSize,
              totalRecords: _ctx.totalTrayekRecords,
              onOnPage: _ctx.onChangePage
            }, null, 8, ["rows", "totalRecords", "onOnPage"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_OverlayPanel, { ref: "refOverlayAction" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListActions, {
          change: _ctx.dataRow.MsVehicle ? true : false,
          edit: false,
          del: true,
          changeTitle: 'Mutasi Kendaraan',
          editTitle: 'Edit Slot',
          delTitle: 'Hapus Slot',
          onChange: _ctx.onChange,
          onEdit: _ctx.onEdit,
          onDel: _ctx.onDelete
        }, null, 8, ["change", "onChange", "onEdit", "onDel"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_HjpDefaultModal, {
      show: _ctx.showDialogForm,
      onHideDialog: _ctx.hideDialogForm
    }, {
      content: _withCtx(() => [
        _createVNode(_component_VehicleMutationForm)
      ]),
      _: 1
    }, 8, ["show", "onHideDialog"]),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.showConfirmDialog,
      title: _ctx.confirmDialog?.title,
      subTitle: _ctx.confirmDialog?.subTitle,
      btnSubmitTitle: _ctx.confirmDialog?.btnSubmitTitle,
      imgContent: _ctx.confirmDialog.imgContent,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.submitFromDialog
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "imgContent", "onHideDialog", "onOnSubmit"]),
    _createVNode(_component_HjpSideBar, {
      show: _ctx.showModalForm,
      onHideDialog: _ctx.hideModalForm,
      canDelete: false
    }, _createSlots({ _: 2 }, [
      (_ctx.showModalForm)
        ? {
            name: "form",
            fn: _withCtx(() => [
              _createVNode(_component_EditSlotForm, { onHideDialog: _ctx.hideModalForm }, null, 8, ["onHideDialog"])
            ])
          }
        : undefined
    ]), 1032, ["show", "onHideDialog"]),
    _createVNode(_component_HjpAlertModal, {
      show: _ctx.isShowAlertDialog,
      title: _ctx.alertDialog?.title,
      subTitle: _ctx.alertDialog?.subTitle,
      btnSubmitTitle: _ctx.alertDialog?.btnSubmitTitle,
      imgContent: _ctx.alertDialog.imgContent,
      onHideDialog: _ctx.hideAlertDialog,
      onOnSubmit: _ctx.hideAlertDialog
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "imgContent", "onHideDialog", "onOnSubmit"])
  ]))
}